/* eslint-disable max-len */
import React from 'react';

interface IPlusProps {
    width?: number;
    height?: number;
}

const Plus: React.FC<IPlusProps> = ({width, height}) => {
    const gradientId = `plus_grad_${Math.random().toString(36).slice(2)}`;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23 0C35.7025 0 46 10.2975 46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0ZM23 12.3008C22.1717 12.3009 21.5 12.9724 21.5 13.8008V21.501H13.7998C12.9715 21.5011 12.2998 22.1726 12.2998 23.001C12.2999 23.8293 12.9715 24.5009 13.7998 24.501H21.5V32.2012C21.5002 33.0294 22.1718 33.7011 23 33.7012C23.8282 33.7011 24.4998 33.0294 24.5 32.2012V24.501H32.2002L32.3535 24.4932C33.1097 24.4162 33.7001 23.7774 33.7002 23.001C33.7002 22.2245 33.1097 21.5858 32.3535 21.5088L32.2002 21.501H24.5V13.8008C24.5 12.9724 23.8283 12.3009 23 12.3008Z"
                fill={`url(#${gradientId})`}
            />
            <defs>
                <linearGradient
                    id={gradientId}
                    x1="0"
                    y1="23"
                    x2="46"
                    y2="23"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white"/>
                    <stop offset="1" stopColor="#E7E7E7"
                    />
                </linearGradient>
            </defs>
        </svg>

    );

};

export default Plus;